import { render, staticRenderFns } from "./PaginationFunctional.vue?vue&type=template&id=03bfd592&"
import script from "./PaginationFunctional.vue?vue&type=script&lang=js&"
export * from "./PaginationFunctional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports